import api from './api';

export function getLineasDeCredito() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/lineas-credito`);
}

export function postIsBonoSocial(data) {
    return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/gestion-politicas/bono-social`,data);
}

export function postCalcularBonoSocial(data) {
    return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/simulacion/calcular-bono-social`,data);
}